export default __webpack_public_path__ + "static/media/icon.0c2a5cfa.png";